import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { SitesTableEvsesPerStateCellComponent } from '../../../pages/sites/components/sites-table-evses-per-state-cell';
import { SitesTableVehiclesPerStateCellComponent } from '../../../pages/sites/components/sites-table-vehicles-per-state-cell';
import { SiteAtAGlanceViewModel } from './site-at-a-glance.view-model';

@Component({
  selector: 'app-site-at-a-glance',
  imports: [TranslatePipe, SitesTableVehiclesPerStateCellComponent, SitesTableEvsesPerStateCellComponent],
  templateUrl: './site-at-a-glance.component.html',
  host: {
    class: 'flex items-end gap-2',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SiteAtAGlanceComponent {
  public readonly vm = input.required<SiteAtAGlanceViewModel>();
}
